import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Form } from 'reactstrap';
import { CardBody } from 'reactstrap';
import AdditionalInfoFieldset from './fieldsets/AdditionalInfoFieldset';
import DescriptionsFieldset from './fieldsets/DescriptionsFieldset';
import { stepValidationFactory } from 'actions/submissionFormActions';
import scrollToFirstError from 'lib/utils/scrollToFirstError';
import TagsFieldset from './fieldsets/TagsFieldset';

class DetailsForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    formErrors: PropTypes.object,
    isLoading: PropTypes.bool,
    categories: PropTypes.array.isRequired,
    currencies: PropTypes.array.isRequired,
    config: ImmutablePropTypes.map.isRequired,
  }

  render() {
    const { formErrors, isLoading, categories, handleSubmit, currencies, config } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <fieldset disabled={isLoading}>
          <div className="card-header">
            <h4>Event Details</h4>
          </div>
          <DescriptionsFieldset formErrors={formErrors}/>
          <TagsFieldset/>
          <CardBody>
            <AdditionalInfoFieldset
              formErrors={formErrors}
              categories={categories}
              currencies={currencies}
              config={config}
            />
          </CardBody>
        </fieldset>
        <button type="submit" className="d-none" />
      </Form>
    );
  }
}

export default reduxForm({
  form: 'eventSubmission',
  destroyOnUnmount: false,
  asyncValidate: stepValidationFactory('details'),
  onSubmitFail: scrollToFirstError,
  persistentSubmitErrors: true,
})(DetailsForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/DetailsForm.jsx